import { Link } from 'react-router-dom';
import { Network, ArrowRight, Briefcase, Globe } from 'lucide-react';

/**
 * Career-Bridge block injected at the footer of every university / course profile page.
 * Reinforces the ZAFCO global recruitment + study-abroad synergy.
 */
const CareerBridgeBlock = ({ context = 'university', countryName = '' }) => {
  return (
    <section className="bg-gradient-to-br from-[#001F5C] via-[#003087] to-[#001F5C] py-14 lg:py-16 relative overflow-hidden" data-testid="sa-career-bridge">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#C5A028] rounded-full blur-[140px]" />
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#C5A028] rounded-full blur-[120px]" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
        <div className="lg:col-span-3">
          <div className="inline-flex items-center gap-2 bg-[#C5A028]/15 border border-[#C5A028]/40 rounded-full px-3 py-1 mb-4">
            <Network className="w-3.5 h-3.5 text-[#C5A028]" />
            <span className="text-[11px] text-[#FACC15] font-semibold uppercase tracking-widest">Powered by ZAFCO&apos;s Global Network</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold font-syne text-white leading-tight mb-3">
            We don&apos;t just get you a degree.<br />
            <span className="text-[#C5A028]">We bridge your path to a global career.</span>
          </h2>
          <p className="text-sm text-slate-300 leading-relaxed mb-5 max-w-2xl">
            For 12+ years, ZAFCO has placed thousands of professionals across the UAE, Germany, UK and beyond.
            Your {context === 'university' ? `${countryName || 'overseas'} degree` : 'study-abroad journey'} unlocks
            direct access to our 5,000+ employer network — from the moment you graduate.
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/study-abroad/book-counselling/?source=career-bridge-block"
              className="inline-flex items-center gap-2 bg-[#C5A028] hover:bg-[#EAB308] text-black font-bold text-sm px-6 py-3 rounded-full transition-all"
              data-testid="sa-career-bridge-cta"
            >
              Talk to a Career Advisor <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/study-abroad/careers/"
              className="inline-flex items-center gap-2 text-sm font-semibold text-white/90 hover:text-[#C5A028]"
            >
              Browse career guides →
            </Link>
          </div>
        </div>
        <div className="lg:col-span-2 grid grid-cols-2 gap-3">
          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-xl p-4">
            <Briefcase className="w-5 h-5 text-[#C5A028] mb-2" />
            <div className="text-2xl font-bold font-syne text-white">5,000+</div>
            <div className="text-[11px] text-slate-400 uppercase tracking-wider mt-1">Global Employers</div>
          </div>
          <div className="bg-white/5 backdrop-blur border border-white/10 rounded-xl p-4">
            <Globe className="w-5 h-5 text-[#C5A028] mb-2" />
            <div className="text-2xl font-bold font-syne text-white">12+</div>
            <div className="text-[11px] text-slate-400 uppercase tracking-wider mt-1">Countries Active</div>
          </div>
          <div className="col-span-2 bg-white/5 backdrop-blur border border-white/10 rounded-xl p-4">
            <div className="text-[11px] text-slate-400 uppercase tracking-wider mb-1">Govt. of India Approved</div>
            <div className="text-xs text-white font-semibold leading-snug">MEA RC: B-0762/DEL/PER/1000+/5/9148/2015</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerBridgeBlock;
